// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2qD0l","info":"Note_info__flnYs","note":"Note_note__2eeuo","actions":"Note_actions__mi0ZL"};